export default function ModalFooter(props) {
  return <div className={`modal-footer ${props.className ?? props.class ?? ""}`}>{props.children}</div>;
}
